import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Card } from 'reactstrap'

function SkeletonTaskList(){
    return <Card color="dark" body>
        <h3 className="text-light"><Skeleton width={400} height={40} style={{maxWidth: "100%"}} /></h3>
        <div className="d-flex justify-content-between">
            <ul class="list-unstyled mb-2 mb-sm-0 mr-md-2" style={{lineHeight: "30px"}}>
                <li><Skeleton width={250} style={{maxWidth: "100%"}} /></li>
                <li><Skeleton width={250} style={{maxWidth: "100%"}} /></li>
                <li><Skeleton width={250} style={{maxWidth: "100%"}} /></li>
                <li><Skeleton width={250} style={{maxWidth: "100%"}} /></li>
                <li><Skeleton width={250} style={{maxWidth: "100%"}} /></li>
            </ul>
            <div className="d-none d-sm-block">              
                <Skeleton height={40} width={200} style={{maxWidth: "100%"}} /><br />
                <Skeleton height={40} width={200} style={{maxWidth: "100%"}} /><br />
                <Skeleton height={40} width={200} style={{maxWidth: "100%"}} />
            </div>
        </div>
        <div className="d-block d-sm-none">   
            <Skeleton height={40} width={200} style={{maxWidth: "100%"}} /><br />
            <Skeleton height={40} width={200} style={{maxWidth: "100%"}} /><br />
            <Skeleton height={40} width={200} style={{maxWidth: "100%"}} />
        </div>
    </Card>
}

export default SkeletonTaskList